export enum BundleType {
  ALIGNER = "aligner-bundle",
  RETAINER = "retainer-bundle",
  ALACARTE = "alacarte"
}